export default "__VITE_ASSET__DEGMx9fR__"